import { SelectListItem } from './select-property'

export const Options_DataType: SelectListItem[] = [
    { value: '1', text: 'Data View', index: 1 },
    { value: '2', text: 'File Folder', index: 2 },
    { value: '3', text: 'FTP', index: 3 }
];
